import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedContent from './components/FeaturedContent';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="4688.tv 官方落地页 – 精彩内容一触即达"
        description="4688.tv 是您值得信赖的在线视频平台，汇聚海量精彩内容，高清流畅播放，随时随地畅享娱乐体验。访问 4688.tv，发现更多优质视频资源，注册即享专属福利。"
        keywords="4688.tv,4688.tv官网,4688.tv在线视频,4688.tv高清播放,4688.tv注册登录,4688.tv最新内容,4688.tv会员福利"
      />

      <SchemaOrg
        type="Organization"
        data={{
          name: '4688.tv',
          url: 'https://4688.tv',
          description: '4688.tv 是您值得信赖的在线视频平台，汇聚海量精彩内容，高清流畅播放。',
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '4688.tv',
          url: 'https://4688.tv',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://4688.tv/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedContent />
        <FAQSection />

        <SchemaOrg
          type="FAQPage"
          data={{
            mainEntity: [
              {
                '@type': 'Question',
                name: '4688.tv 是否需要付费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '4688.tv 提供免费和付费两种观看模式。部分内容支持免费观看（含广告），会员用户可享受无广告、超高清画质、离线下载、独家内容等专属权益。',
                },
              },
              {
                '@type': 'Question',
                name: '如何注册 4688.tv 账号？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过手机号、邮箱或第三方账号快速注册 4688.tv 账号，注册过程简单快捷，仅需1-2分钟。',
                },
              },
              {
                '@type': 'Question',
                name: '4688.tv 支持哪些设备观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '4688.tv 支持全终端观看，包括网页端、移动端、平板端、智能电视和游戏主机。',
                },
              },
            ],
          }}
        />

        <CTASection />
      </main>
    </>
  );
}